
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Tabs, Tab, } from '@material-ui/core';
import MBack from '../view/MBack';
import { MatchLeagueItemHot, MatchLeagueItemCountry } from './view';
import MTabPanel from '../view/MTabPanel';
import Apis from '../../network/Apis';
import MTabsButton from '../view/MTabsButton';
import AppUtils from '../../control/apputlis';
import TabIndicator from '../view/TabIndicator';


class MatchArea extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            typeTabs: 0,
            countrys: [],
            competitions: [],
            tabs: [],
        };
        console.log('MatchArea', props);
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'MatchArea');
        const { typeId } = this.props.match.params;
        this.getAddress(typeId);
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getAddress = async (type_id) => {
        let result = await Apis.encryptionAddress(type_id);
        console.log('getAddress', result);
        if (result.code == 200 && result.data) {
            this.setState({ tabs: result.data });
            if (result.data.length > 0) {
                this.getAreaCompetitionCountry(type_id, result.data[0].id);
            }
        }
    }



    getAreaCompetitionCountry = async (type_id, category_id, country_id) => {
        let countrys = [];
        let competitions = [];
        let result = await Apis.encryptionAddressComList(type_id, category_id, country_id);
        console.log('getAreaCompetition', result);
        if (result.code == 200) {
            let data = [];
            for (let i = 0; i < result.data.length; i++) {
                data.push({
                    competition_id: result.data[i].id,
                    short_name_zh: result.data[i].name,
                    type_id: type_id,
                    logo: result.data[i].logo,
                    name: result.data[i].name,
                });
            }
            competitions = data;
        }

        result = await Apis.encryptionAddressCountry(type_id, category_id);
        console.log('getAreaCountry', result);
        if (result.code == 200) {
            countrys = result.data;
        }
        this.setState({ countrys: countrys, competitions: competitions });
    }

    _handleChange(val) {
        this.setState({ value: val, data: [] }, () => {
            const { typeId } = this.props.match.params;
            const { tabs } = this.state;
            this.getAreaCompetitionCountry(typeId, tabs[val].id);
        });
    }

    _handleTypeChange = (val) => {
        this.setState({ typeTabs: val });
    }

    renderPannel = () => {
        const { classes } = this.props;
        const { countrys, competitions, typeTabs, value, tabs } = this.state;
        let showTabs = countrys && countrys.length > 0 && competitions && competitions.length > 0;
        const { typeId } = this.props.match.params;

        if (showTabs) {
            return (
                <Grid container direction='row' spacing={1} className={classes.root}>
                    {
                        typeTabs == 0 && countrys.map((item, i) => (
                            <Grid key={i} item xs={3} className={classes.gridlist}>
                                <MatchLeagueItemCountry data={item} typeId={typeId} categoryId={tabs[value].id} />
                            </Grid>
                        ))
                    }
                    {
                        typeTabs == 1 && competitions.map((item, i) => (
                            <Grid key={i} item xs={3} className={classes.gridlist}>
                                <MatchLeagueItemHot data={item} />
                            </Grid>
                        ))
                    }
                </Grid>

            )
        } else {
            if (countrys && countrys.length) {
                return (
                    <Grid container direction='row' spacing={1} className={classes.root}>
                        {
                            countrys.map((item, i) => (
                                <Grid key={i} item xs={3} className={classes.gridlist}>
                                    <MatchLeagueItemCountry data={item} />
                                </Grid>
                            ))
                        }
                    </Grid>
                );
            } else {
                if (competitions && competitions.length) {
                    return (
                        <Grid container direction='row' spacing={1} className={classes.root}>
                            {
                                competitions.map((item, i) => (
                                    <Grid key={i} item xs={3} className={classes.gridlist}>
                                        <MatchLeagueItemHot data={item} />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    );
                }
            }
        }

    }

    renderContent = (item, i) => {
        const { classes } = this.props;
        const { value, countrys, competitions, typeTabs } = this.state;
        let showTabs = countrys && countrys.length > 0 && competitions && competitions.length > 0;
        return (
            <MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}>
                <Grid container direction='row' spacing={1} className={classes.root}>
                    {
                        showTabs && <Grid container style={{ marginTop: 8, marginBottom: 8 }}  >
                            <MTabsButton data={['国家赛事', '洲际赛事']} onChange={(v) => this._handleTypeChange(v)} />
                        </Grid>
                    }
                    {
                        this.renderPannel()
                    }
                </Grid>
            </MTabPanel>
        );
    }

    render() {
        const { classes } = this.props;
        const { value, tabs } = this.state;
        return (
            <MBack title={'地区赛事'}>
                <Grid container justifyContent='space-between' alignItems='center' direction='row'>
                    <Grid container alignItems='center' style={{ flex: 1, backgroundColor: '#FFF', marginTop: 8 }}>
                        {
                            tabs && tabs.length > 0 && <Tabs
                                value={value}
                                variant='fullWidth'
                                onChange={(e, val) => this._handleChange(val)}
                                TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                                style={{ minHeight: 32, width: '100vw' }}
                            >
                                {
                                    tabs.map((item, i) => (
                                        <Tab key={i} label={item.name_zh} style={{ color: value == i ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                                    ))
                                }
                            </Tabs>
                        }
                    </Grid>
                </Grid>
                <Grid style={{ height: 1, backgroundColor: '#F7F7F7', width: '100%' }}></Grid>
                <Grid container direction='row' className={classes.list} >
                    {
                        tabs.map((item, i) => (
                            this.renderContent(item, i)
                        ))
                    }
                </Grid>
            </MBack>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    root: {
        padding: theme.spacing(1, 1, 1, 1)
    },
    list: {
        padding: theme.spacing(0, 0, 0, 0),
        marginTop: theme.spacing(0),
        backgroundColor: '#FFF',
    },
    gridlist: {
        padding: theme.spacing(0, 0.5, 0, 0.5)
    },

}))(MatchArea));